import { ArticleCard } from '@components/common'
import cn from 'clsx'
import Link from 'next/link'
interface Props {
  slice: any
}
const FeaturedArticles = ({ slice }: Props) => {
  const { primary } = slice
  const layout = primary?.layout
  const leftArticle = primary?.leftArticle
  const rightArticle = primary?.rightArticle
  const linkText = primary?.linkText
  const link = primary?.link

  return (
    <>
      <div className="wrapper flex flex-col bg-ui-light-grey pt-0 pb-8 lg:pt-30 lg:pb-20">
        <div className=" hidden gap-8 lg:grid lg:grid-cols-12">
          <div
            className={cn(
              'col-span-3',
              { 'lg:col-span-4 lg:col-start-2': layout },
              { 'lg:col-span-5 lg:col-start-2': !layout }
            )}
          >
            <ArticleCard
              featured
              uid={leftArticle?.uid}
              article={leftArticle?.data}
            />
            {link && linkText && !layout && (
              <Link href={link} passHref>
                <div className="mt-20 cursor-pointer font-roboto  text-2xl font-light text-brand-dark-grey underline hover:opacity-75">
                  {linkText}
                </div>
              </Link>
            )}
          </div>
          <div
            className={cn(
              'col-span-3 flex flex-col',
              { 'lg:col-span-5 lg:col-start-7': layout },
              { 'lg:col-span-4 lg:col-start-8': !layout }
            )}
          >
            <ArticleCard
              featured
              uid={rightArticle?.uid}
              article={rightArticle?.data}
            />
            {link && linkText && layout && (
              <Link href={link} passHref>
                <div className="mt-20 cursor-pointer self-end font-roboto  text-2xl font-light text-brand-dark-grey underline hover:opacity-75">
                  {linkText}
                </div>
              </Link>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-[52px] lg:hidden">
          <div className="featuredArticleContainer grid overflow-x-scroll lg:hidden">
            <ArticleCard
              featured
              uid={leftArticle?.uid}
              article={leftArticle?.data}
            />
            <ArticleCard
              featured
              uid={rightArticle?.uid}
              article={rightArticle?.data}
            />
          </div>
          {link && linkText && (
            <Link href={link} passHref>
              <div className="heading-mobile-4 self-center underline hover:opacity-75">
                {linkText}
              </div>
            </Link>
          )}
        </div>
      </div>
      <style jsx>
        {`
          .stockistContainer {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .featuredArticleContainer::-webkit-scrollbar {
            display: none;
          }
          @media (max-width: 1023px) {
            .featuredArticleContainer {
              --visible-cols: 2;
              --col-gap: 24px;
              --col-hint: 0px;
              --col-size: calc(
                (100% / var(--visible-cols)) - var(--col-gap) - var(--col-hint)
              );
              grid-auto-flow: column;
              grid-template-columns: var(--col-size);
              grid-auto-columns: var(--col-size);
              grid-gap: 24px;
            }
          }
          @media (max-width: 425px) {
            .featuredArticleContainer {
              --visible-cols: 1;
              --col-gap: 24px;
              --col-hint: 80px;
              --col-size: calc(
                (100% / var(--visible-cols)) - var(--col-gap) - var(--col-hint)
              );
              grid-auto-flow: column;
              grid-template-columns: var(--col-size);
              grid-auto-columns: var(--col-size);
              grid-gap: 24px;
            }
          }
        `}
      </style>
    </>
  )
}

export default FeaturedArticles
